import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, GithubAuthProvider } from "firebase/auth";
import {
  getFirestore,
  serverTimestamp as firestoreServerTimestamp,
} from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const config = {
  apiKey: "AIzaSyC5N3NcR-qjMiLpyhXSiU74i-UTXpqf-N4",
  authDomain: "auth.app.kappaml.com",
  projectId: "kappaml",
  storageBucket: "kappaml.appspot.com",
  messagingSenderId: "476967615457",
  appId: "1:476967615457:web:d371295953e71b53a970a0",
  measurementId: "G-DKB4DSGGM1",
};

// Initialize Firebase
const app = initializeApp(config);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Initialize Auth
export const firebaseAuth = getAuth(app);
export const googleAuthProvider = new GoogleAuthProvider();
export const githubAuthProvider = new GithubAuthProvider();

// Initialize Firestore
export const firestore = getFirestore(app);
export const serverTimestamp = firestoreServerTimestamp;

export default app;
